import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { FaBinoculars, FaPersonHiking, FaUmbrellaBeach, FaUsers, FaRoute, FaCompass } from "react-icons/fa6";

import banner1 from "../assets/banner1.jpg";
import wild_plains from "../assets/wild_plains.jpg";
import banner2 from "../assets/banner2.jpg";
import banner4 from "../assets/zanzibar2.jpg";
import summit from "../assets/summit.jpg";
import camp from "../assets/camp.jpg";
import adventure from "../assets/adventure.jpg";
import beach from "../assets/beach.jpg";
import trip from "../assets/trips.jpg";
import wild from "../assets/wild.jpeg";
import premium from "../assets/premium.jpeg";
import diverse from "../assets/diverse.jpeg";
import lux from "../assets/lux.jpeg";

export default function HomeBanner2() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);
  const [slideIndex, setSlideIndex] = useState(0);
  const [cinematicInView, setCinematicInView] = useState(false);
  const cinematicRef = useRef(null);

  const slides = useMemo(
    () => [
      {
        image: adventure,
        title: "Adventure Circuits",
        text: "Blended wildlife and culture routes through northern Tanzania for travelers who want a bit of everything.",
        icon: <FaRoute size={19} />,
        subItem: "adventure",
      },
      {
        image: banner2,
        title: "Safari Experiences",
        text: "Serengeti, Ngorongoro, Tarangire, and Manyara itineraries with private guides and flexible pacing.",
        icon: <FaBinoculars size={19} />,
        subItem: "safaris",
      },
      {
        image: summit,
        title: "Kilimanjaro & Trekking",
        text: "High-support climbs via Lemosho, Marangu, and Northern Circuit routes tailored to your fitness level.",
        icon: <FaPersonHiking size={19} />,
        subItem: "trekking",
      },
      {
        image: beach,
        title: "Zanzibar Beach Holidays",
        text: "Stone Town, spice tours, and oceanfront stays designed as stand-alone trips or post-safari extensions.",
        icon: <FaUmbrellaBeach size={19} />,
        subItem: "zanzibar",
      },
      {
        image: trip,
        title: "Cultural Day Trips",
        text: "Meaningful community visits, local cuisine, and heritage stories guided with respect and authenticity.",
        icon: <FaUsers size={19} />,
        subItem: "day_trips",
      },
      {
        image: banner2,
        title: "Tailor-Made Luxury",
        text: "Handpicked lodges, private transfers, and premium pacing for couples, families, or small groups.",
        icon: <FaCompass size={19} />,
        subItem: "luxury",
      },
    ],
    []
  );

  useEffect(() => {
    setReady(true);
  }, []);

  useEffect(() => {
    if (!ready) return;
    const interval = setInterval(() => {
      setSlideIndex((prev) => (prev + 1) % slides.length);
    }, 4200);
    return () => clearInterval(interval);
  }, [ready, slides.length]);

  useEffect(() => {
    if (!ready || !cinematicRef.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setCinematicInView(true);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.28 }
    );
    observer.observe(cinematicRef.current);
    return () => observer.disconnect();
  }, [ready]);

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  function goNext() {
    setSlideIndex((prev) => (prev + 1) % slides.length);
  }

  function goPrev() {
    setSlideIndex((prev) => (prev - 1 + slides.length) % slides.length);
  }

  function openService(subItem) {
    appContext.navTo({
      item: "services",
      subItem,
    });
  }

  return (
    <section
      className="MainBodySection py-5"
      style={{
        background: "linear-gradient(180deg, #f5f9f7 0%, #edf5f2 100%)",
      }}
    >

<div className="aboutc-cinematic-bleed mt-3 mb-5 pb-2" data-aos="fade-up">
        <div
          ref={cinematicRef}
          className={`aboutc-cinematic ${cinematicInView ? "in-view" : ""}`}
          aria-label="Signature visual moments"
          style={{oveflowX:"hidden !important"}}
        >
          <article className="aboutc-cinematic-tile aboutc-cinematic-image" style={{ "--tile-index": 0 }}>
            <img src={wild} alt="Safari game drive across open plains" style={{height:"100%", width:"auto"}}/>
            <div className="aboutc-cinematic-overlay">
              <p className="mb-0 font-semi-bold">Wild Plains</p>
            </div>
          </article>
          <article className="aboutc-cinematic-tile aboutc-cinematic-image" style={{ "--tile-index": 1 }}>
            <img src={lux} alt="Luxury safari camp atmosphere" style={{height:"100%", width:"auto"}}/>
            <div className="aboutc-cinematic-overlay">
              <p className="mb-0 font-semi-bold">Luxury Stays</p>
            </div>
          </article>
          <article className="aboutc-cinematic-tile aboutc-cinematic-image" style={{ "--tile-index": 2 }}>
            <img src={diverse} alt="Coastal and mountain adventure route" style={{height:"100%", width:"auto"}}/>
            <div className="aboutc-cinematic-overlay">
              <p className="mb-0 font-semi-bold">Diverse Routes</p>
            </div>
          </article>
          <article className="aboutc-cinematic-tile aboutc-cinematic-premium" style={{ "--tile-index": 3 }}>
            <img src={premium} alt="Premium tailor-made journey concept" className="aboutc-cinematic-premium-bg" />
            <div className="aboutc-cinematic-premium-blur" />
            <div className="aboutc-cinematic-premium-content">
              <h3 className="font-semi-bold mb-2">Premium Journeys</h3>
              <p className="mb-0">
                Every route is handcrafted with private logistics, thoughtful pacing, and premium on-ground support.
              </p>
            </div>
          </article>
        </div>
      </div>


      <div className="container">
        <div className="mx-auto" style={{ maxWidth: 1060 }}>
          <div className="text-center mb-4" data-aos="fade-right">
            <div className="section-heading-pro section-heading-pro--center">
              <h2 className="section-heading-pro__title font-bold" style={{ color: "#162739" }}>
                Choose Your Adventure Style
              </h2>
              <p className="section-heading-pro__meta mb-0">Travel Experiences</p>
            </div>
            <p className="mb-0" style={{ color: "#5a6775", maxWidth: 760, margin: "0 auto" }}>
              Every journey is flexible, private, and planned around your travel rhythm from wildlife to mountain and coast.
            </p>
          </div>

          <div
            data-aos="fade-down"
            style={{
              position: "relative",
              borderRadius: 24,
              overflow: "hidden",
              minHeight: 430,
              boxShadow: "0 20px 44px rgba(8, 39, 37, 0.2)",
            }}
          >
            {slides.map((slide, index) => (
              <article
                key={slide.title}
                style={{
                  position: "absolute",
                  inset: 0,
                  opacity: index === slideIndex ? 1 : 0,
                  transform: index === slideIndex ? "scale(1)" : "scale(1.02)",
                  transition: "opacity .6s ease, transform .6s ease",
                }}
              >
                <img
                  src={slide.image}
                  alt={slide.title}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    background: "linear-gradient(180deg, rgba(8, 32, 25, .14), rgba(8, 28, 36, .84))",
                  }}
                />

                <div
                  style={{
                    position: "absolute",
                    left: 22,
                    right: 22,
                    bottom: 22,
                    color: "#fff",
                    textAlign: "center",
                  }}
                >
                  <p
                    className="mb-2 d-inline-flex align-items-center font-semi-bold"
                    style={{
                      padding: "6px 12px",
                      borderRadius: 99,
                      border: "1px solid rgba(255,255,255,.34)",
                      fontSize: 11.5,
                      letterSpacing: 1,
                      textTransform: "uppercase",
                    }}
                  >
                    Signature Experience
                  </p>
                  <h3 className="font-bold mb-2" style={{ fontSize: "clamp(24px, 3.6vw, 36px)" }}>
                    {slide.title}
                  </h3>
                  <p className="mb-0" style={{ maxWidth: 820, margin: "0 auto", lineHeight: 1.65 }}>
                    {slide.text}
                  </p>
                </div>
              </article>
            ))}

            <button
              type="button"
              onClick={goPrev}
              aria-label="Previous"
              style={{
                position: "absolute",
                top: 16,
                left: 16,
                width: 38,
                height: 38,
                borderRadius: 11,
                border: "none",
                background: "rgba(255,255,255,.92)",
                boxShadow: "0 10px 20px rgba(7,24,32,.18)",
              }}
            >
              <IoChevronBack size={19} />
            </button>
            <button
              type="button"
              onClick={goNext}
              aria-label="Next"
              style={{
                position: "absolute",
                top: 16,
                right: 16,
                width: 38,
                height: 38,
                borderRadius: 11,
                border: "none",
                background: "rgba(255,255,255,.92)",
                boxShadow: "0 10px 20px rgba(7,24,32,.18)",
              }}
            >
              <IoChevronForward size={19} />
            </button>
          </div>

          <div className="row mt-4 g-3" data-aos="fade-right">
            {slides.map((item, index) => (
              <div key={item.title} className="col-md-6">
                <button
                  type="button"
                  onMouseEnter={() => setSlideIndex(index)}
                  onFocus={() => setSlideIndex(index)}
                  onClick={() => openService(item.subItem)}
                  className="w-100 text-start"
                  style={{
                    border: "none",
                    borderBottom: index === slideIndex ? "2px solid #0e5748" : "1px solid #d8e4df",
                    background: "transparent",
                    padding: "10px 0 12px",
                    color: "#152638",
                    transition: "all .2s ease",
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 10,
                  }}
                >
                  <span
                    style={{
                      width: 34,
                      height: 34,
                      borderRadius: 999,
                      display: "grid",
                      placeItems: "center",
                      background: index === slideIndex ? "#0e5748" : "#e8f1ee",
                      color: index === slideIndex ? "#f2c45e" : "#3f5f57",
                      flexShrink: 0,
                    }}
                  >
                    {item.icon}
                  </span>

                  <span>
                    <span className="font-semi-bold d-block" style={{ fontSize: 18 }}>
                      {item.title}
                    </span>
                    <span style={{ color: "#56677a", fontSize: 14.5, lineHeight: 1.55 }}>
                      {item.text}
                    </span>
                  </span>
                </button>
              </div>
            ))}
          </div>

          

          
        </div>
      </div>
    </section>
  );
}
